import { state2 } from '../../shared/state';
import { Component, OnInit } from '@angular/core';
import { NotitiesService, IPartij, IPersoon, INieuweNotitie } from '../notities.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppRoutingService } from 'src/app/shared/app-routing.service';
import { map, mergeMap } from 'rxjs/operators';
import { zip, Subject, Observable } from 'rxjs';
import { createCmdFactory } from '@cevi/rxjscommands';
import { FormsModule } from '@angular/forms';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';

interface INotitieToevoegenVm {
  zittingId: number;
  notitie: INieuweNotitie;
  partijen: IPartij[];
  notitiecontent: string;
  allenSelected: boolean;

}

@Component({
    selector: 'app-notitie-toevoegen',
    templateUrl: './notitie-toevoegen.component.html',
    styleUrls: ['./notitie-toevoegen.component.scss'],
    standalone: true,
    imports: [NgIf, FormsModule, NgFor, AsyncPipe],
    providers:[NotitiesService]
})
export class NotitieToevoegenComponent implements OnInit {

  public vm$: Observable<INotitieToevoegenVm>;
  public vm: INotitieToevoegenVm;

  constructor(private notitieService: NotitiesService,
    private routing: AppRoutingService,
    private route: ActivatedRoute, private router: Router) {
    this.routing.createCurrentHistoryItem('Notitie toevoegen');

    const cmdFactory = createCmdFactory<INotitieToevoegenVm>();
    cmdFactory.addMapAction(this.viewDataAction$, 'viewdataAction');
    cmdFactory.addMapAction(this.toggleAllenAction$, 'toggleAllenAction');
    cmdFactory.addMapAction(this.togglePartijAction$, 'togglePartijAction');
    cmdFactory.addMapAction(this.togglePersoonAction$, 'togglePersoonAction');
    cmdFactory.addMapAction(this.saveAction$, 'saveAction');

    this.vm$ = cmdFactory.merge({
      zittingId: 0,
      allenSelected: false,
      notitie: {},
      partijen: [],
      notitiecontent: ''
    } as INotitieToevoegenVm);

  }

  private params$ = this.route.paramMap.pipe(
    map(p => ({
      zittingId: + p.get('zittingId'),
      notitie: { AgendapuntId: +p.get('agendapuntId'), NotitieContent: '', PersoonIds: [] },
      agendapuntId: +p.get('agendapuntId')
    }))
  );

  private actieveLedenPerPartij$ = this.params$.pipe(
    mergeMap(({ agendapuntId }) => this.notitieService.getActieveLedenPerPartij(agendapuntId))
  );

  private viewDataAction$ = zip(this.actieveLedenPerPartij$, this.params$).pipe(
    map(([partijen, params]) => (vm: INotitieToevoegenVm) => ({ ...vm, partijen, notitie: params.notitie }))
  );

  public toggleAllenSubj = new Subject<boolean>();
  private toggleAllenAction$ = this.toggleAllenSubj.pipe(
    map(isSelected => (vm: INotitieToevoegenVm) => {
      const partijen = vm.partijen.map(partij => ({
        ...partij,
        isSelected,
        Leden: partij.Leden.map(lid => ({ ...lid, isSelected:isSelected || !lid.canSelect }))
      }));
      return { ...vm, allenSelected: isSelected, partijen };
    })
  );

  public togglePartijSubj = new Subject<IPartij>();
  private togglePartijAction$ = this.togglePartijSubj.pipe(
    map(partij => (vm: INotitieToevoegenVm) => {
      partij.isSelected = !partij.isSelected;
      partij.Leden.forEach(persoon => {
        persoon.isSelected = partij.isSelected || !persoon.canSelect;
      });
      this.checkAllen2(vm);
      return vm;
    })
  );

  public togglePersoonSubj = new Subject<IPersoon>();
  private togglePersoonAction$ = this.togglePersoonSubj.pipe(
    map(persoon => (vm: INotitieToevoegenVm) => {
      persoon.isSelected = !persoon.isSelected || !persoon.canSelect;
      this.checkPartijen2(vm);
      return vm;
    })
  );

  public saveSubj = new Subject<INotitieToevoegenVm>();
  private saveAction$ = this.saveSubj.pipe(
    mergeMap(vm => {
      vm.notitie.PersoonIds = [];
      const selected = vm.partijen.map(partij => partij.Leden.filter(p => p.isSelected).map(p => p.Id));
      vm.notitie.PersoonIds = selected.reduce((prev, curr) => { prev.push(...curr); return prev; }, vm.notitie.PersoonIds);
      return this.notitieService.toevoegenNotitie(vm.notitie);
    }),
    map(result => (vm: INotitieToevoegenVm) => {
      this.routing.navigateBack();
      return vm;
    })
  );

  private checkPartijen2(vm: INotitieToevoegenVm) {
    vm.partijen.forEach(partij => {
      partij.isSelected = partij.Leden.reduce((prev, curr) => prev && curr.isSelected, true);
    });
    this.checkAllen2(vm);
  }

  private checkAllen2(vm: INotitieToevoegenVm) {
    vm.allenSelected = vm.partijen.reduce((prev, curr) => prev && curr.isSelected, true);
  }


  ngOnInit() {

  }

  getPartijId = (_: number, partij: IPartij) => partij.Id;
  getLidId = (_: number, lid: IPersoon) => lid.Id;

  cancel() {
    this.routing.navigateBack();
  }
}
